import app from "gatsby-plugin-firebase-v9.0"
import { getFirestore, collection } from "firebase/firestore/lite";

// Firebase Instances
export const firestore = getFirestore(app);

// Collections
export const investors = collection(firestore, "investors_list");
export const founders = collection(firestore, "founders_list");


